import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../styles/Navigation.css";

const Navigation = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          Asset Management
        </Link>

        <div className="navbar-menu">
          {isAuthenticated ? (
            <>
              <Link to="/assets" className="nav-link">
                Assets
              </Link>
              <Link to="/asset-types" className="nav-link">
                Asset Types
              </Link>
              <Link to="/properties" className="nav-link">
                Properties
              </Link>
              <Link to="/branches" className="nav-link">
                Branches
              </Link>
              <button onClick={handleLogout} className="btn btn-sm btn-secondary">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/" className="nav-link">
                Home
              </Link>
              <Link to="/login" className="btn btn-sm btn-primary">
                Login
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
